var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19696_5584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.833496 3.55408V8.55408M0.833496 8.55408H5.8335M0.833496 8.55408L4.70016 4.92074C5.85092 3.77193 7.34387 3.02822 8.95406 2.80167C10.5642 2.57513 12.2044 2.87802 13.6275 3.66471C15.0506 4.4514 16.1795 5.67928 16.844 7.16332C17.5086 8.64737 17.6728 10.3072 17.312 11.8927C16.9512 13.4782 16.0849 14.9035 14.8436 15.9539C13.6023 17.0042 12.0533 17.6227 10.4299 17.7161C8.80657 17.8096 7.19681 17.3729 5.84321 16.4719C4.48961 15.5709 3.46549 14.2544 2.92516 12.7207",
    stroke: "#475467",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19696_5584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.220703)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryTab);
export default __webpack_public_path__ + "static/media/historyTab.3664f6f1f4c83cc379aa210ed9a3a3ac.svg";
export { ForwardRef as ReactComponent };